import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { CheckoutHeader } from '@cencosud-cencommerce/paris-uikit';

import { useAppSelector } from '@/Application/Hooks/Redux';
import ExitIntentModal from '@/Application/Modals/ExitIntentModal/ExitIntentModal';
import { selectBuyNowErrorFallback } from '@/Application/Selectors/buyNow/useBuyNowCart';
import { URL_ROUTES } from '@/constants';
import { useStorageSession } from '@/modules/perseo-billing/hooks/use-storage-session';
import {
  isDeviceAndroid,
  isDeviceIos,
  isDeviceKiosco
} from '@/modules/perseo-billing/utils';
import {
  BuyNowEventInteractiveCategories,
  BuyNowEventInteractiveTags
} from '@/modules/shared/utils/gtmEvents/buyNowTypes';
import { sendEvent } from '@/modules/shared/utils/gtmEvents/sendEvents/sendBuyNowEvents';
import { useMergeFastCheckoutCart } from '@/Pages/BuyNowPage/hooks/useMergeFastCheckoutCart';

export const BuyNowHeader = () => {
  const location = useLocation();
  const isWebView = isDeviceAndroid() || isDeviceIos() || isDeviceKiosco();
  const { user } = useStorageSession();
  const [modalOpen, setModalOpen] = useState(false);
  const isErrorFallback = useAppSelector(selectBuyNowErrorFallback);
  const { isLoading: isMerging, mergeAndRedirectToHome } =
    useMergeFastCheckoutCart();

  if (isWebView) return <></>;

  const isBuyNowPage = location.pathname.includes(URL_ROUTES.BUY_NOW);
  const buyNowLabel = isBuyNowPage ? 'Comprar ahora' : undefined;
  const checkoutHeaderVariant = isBuyNowPage ? 'heading' : 'stepIndicator';

  return (
    <div className="co-bg-white co-border-b co-border-neutral-200">
      <CheckoutHeader
        variant={checkoutHeaderVariant}
        label={buyNowLabel}
        brand={{
          link: '#',
          name: 'paris',
          onClick: () => {
            if (isMerging) return;

            sendEvent({
              event: 'baseEvent',
              extraFields: {
                'event-interactive-tag': BuyNowEventInteractiveTags.Logo,
                'event-interactive-category':
                  BuyNowEventInteractiveCategories.HeaderInteractions
              }
            });

            if (isErrorFallback) {
              mergeAndRedirectToHome();
            } else {
              setModalOpen(true);
            }
          }
        }}
        user={
          user.firstName
            ? {
                name: user.firstName,
                onClick: function noRefCheck() {}
              }
            : undefined
        }
      />
      <ExitIntentModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </div>
  );
};

BuyNowHeader.displayName = 'BuyNowHeader';

export default BuyNowHeader;
